// The single money formatter for frontend_user. Amounts are display-only —
// all real calculation happens on the backend.
//
// Orders carry no currency of their own; the business base currency is USD
// (see README §20), so BASE_CURRENCY is the documented fallback. Products
// and cart lines carry their own `currency`, which always wins.
export const BASE_CURRENCY = "USD";

export function formatMoney(amount, currency) {
  const value = Number(amount);
  const safe = Number.isFinite(value) ? value : 0;
  const code = (currency || BASE_CURRENCY).toUpperCase();
  try {
    return new Intl.NumberFormat("en-US", { style: "currency", currency: code }).format(safe);
  } catch {
    // Not an ISO currency code (free-text currency name): show it verbatim.
    return `${currency} ${safe.toFixed(2)}`;
  }
}
